import React, { useState, useRef, useEffect } from "react";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import { Form, Loader, Modal, Notification, Panel, useToaster } from "rsuite";
import { useLoaderData } from "react-router-dom";
import { DateTime } from "luxon";
import { useSearchParams } from "react-router-dom";
import usePost from "../../customhooks/UsePost";
import Loading from "../../Loder";
const CreateResumeNewLayout = React.lazy(
  () => import("./CreateResumeNewLayout"),
);
const Description = React.lazy(() => import("./Description"));
const WeeklyHours = React.lazy(() => import("./WeeklyHours"));
const Dates = React.lazy(() => import("./Dates"));
const TimeZoneList = React.lazy(() => import("../scheduleVideo/TimeZoneList"));
import axios from "axios";
import ToasterNotification from "../../utilities/ToasterNotification";
import { Placeholder } from "rsuite";

const CareersAvailability = () => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    reset,
    resetField,
    getValues,
    clearErrors,
  } = useForm();

  const {
    post: insertAvailability,
    isLoading,
    error,
  } = usePost("/insertAvailability");
  const {
    post: getAvailability,
    isLoading: isAvailabilityLoading,
    error: availabilityError,
  } = usePost("/getAvailabilityData");

  const {
    post: checkIsCampaignActive,
    isLoading: isCheckIsCampaignActiveLoading,
    error: checkIsCampaignActiveError,
  } = usePost("/checkIsCampaignActive");

  const [searchParams] = useSearchParams();
  let toaster = useToaster();
  const loaderDetails = useLoaderData();
  const { t } = useTranslation();
  const isMountRef = useRef(false);
  const startDateRef = useRef({});
  const endDateRef = useRef({});
  const [rid, setRId] = useState("");
  const [optionSelected, setOptionSelected] = useState([]);
  const [timeZone, setTimeZone] = useState("America/Chicago");
  const [weeklyHourData, setWeeklyHourData] = useState({});
  const [dateClear, setDateClear] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [showModal, setShowModal] = useState(true);
  const [isActiveCampaign, setIsActiveCampaign] = useState(false);
  const activeRef = useRef(false);
  const [activeCampaignLoading, setActiveCampaignLoading] = useState(true);

  const getCookie = async () => {
    try {
      let cookieDetails = await axios.get(
        window.location.origin + "/jsv4/webapi/getcookie",
      );
      cookieDetails = cookieDetails?.data;
      if (cookieDetails["Candidate_ResumeID"]) {
        setRId(cookieDetails["Candidate_ResumeID"]);
      }
    } catch (error) {
      console.log("Error in getCookies : ", error);
    }
  };

  useEffect(() => {
    const fetchCampaignActive = async () => {
      activeRef.current = true;
      let campaignData = await checkIsCampaignActive({
        campaignID: searchParams.get("cid"),
        companyID: searchParams.get("companyid")
          ? searchParams.get("companyid")
          : loaderDetails?.companyID,
      });
      if (campaignData?.result?.status) {
        setIsActiveCampaign(
          campaignData?.result?.result?.status == "Active" ? true : false,
        );
      } else {
        setIsActiveCampaign(true);
      }
      setActiveCampaignLoading(false);
    };
    if (!activeRef.current) {
      fetchCampaignActive();
    }
  }, [searchParams]);

  useEffect(() => {
    if (isActiveCampaign) {
      if (searchParams.get("rid")) {
        setRId(searchParams.get("rid"));
      } else {
        getCookie();
      }
    }
  }, [isActiveCampaign]);

  useEffect(() => {
    const fetchWeeklyHours = async () => {
      if (rid && !isMountRef.current) {
        let weeklyHoursData = await getAvailability({ resumeID: rid });
        console.log(weeklyHoursData, "weeklyHoursDataweeklyHoursData");
        if (
          weeklyHoursData?.result?.status &&
          weeklyHoursData?.result?.result?.length > 0
        ) {
          setWeeklyHourData(weeklyHoursData?.result?.result[0]);
        }
        isMountRef.current = true;
      }
    };

    fetchWeeklyHours();
  }, [rid]);

  const normalizeDateTime = (dateTime) => {
    return DateTime.fromJSDate(dateTime).set({
      millisecond: 0,
      second: 0,
    });
  };

  const validateTimingExists = (timing, slotIdx, timingIdx) => {
    if (!timing?.startTime) {
      setError(`slots[${slotIdx}].timings[${timingIdx}].startTime`, {
        type: "manual",
        message: "Please enter start time",
      });
      return false;
    }
    if (!timing?.endTime) {
      setError(`slots[${slotIdx}].timings[${timingIdx}].endTime`, {
        type: "manual",
        message: "Please enter end time",
      });
      return false;
    }
    return true;
  };

  const validateTimingRange = (timing, slotIdx, timingIdx, day) => {
    const start = normalizeDateTime(timing.startTime).toISO();
    const end = normalizeDateTime(timing.endTime).toISO();
    const zone = optionSelected[0]?.value;
    const now = DateTime.now().setZone(zone);
    if(getValues()?.startDate){
      const selectedDate = DateTime.fromObject(
      {
        year: getValues().startDate.getFullYear(),
        month: getValues().startDate.getMonth() + 1,
        day: getValues().startDate.getDate(), 
      },
      { zone }
      ).startOf("day");
      const starting = selectedDate.set({
        hour: timing.startTime.getHours(),
        minute: timing.startTime.getMinutes(),
        second: 0,
        millisecond: 0,
      });
      const isToday = selectedDate.hasSame(now, "day");
      // const startDateTime = normalizeDateTime(timing.startTime);
      if (isToday && now.weekdayLong == day && starting.toMillis() < now.toMillis()) {
        setError(`slots[${slotIdx}].timings[${timingIdx}].startTime`, {
          type: "manual",
          message: "Start time must be greater than current time",
        });
        return false;
      }
    }

    if (
      DateTime.fromISO(start).toMillis() === DateTime.fromISO(end).toMillis()
    ) {
      setError(`slots[${slotIdx}].timings[${timingIdx}].startTime`, {
        type: "manual",
        message: "Start time and end time cannot be same",
      });
      return false;
    }

    let endDateTime = DateTime.fromISO(end);
    if (DateTime.fromISO(start).toMillis() > DateTime.fromISO(end).toMillis()) {
      endDateTime = endDateTime.plus({ days: 1 });
    }

    const diffInHours = endDateTime
      .diff(DateTime.fromISO(start), "hours")
      .toObject().hours;

    if (diffInHours > 12) {
      setError(`slots[${slotIdx}].timings[${timingIdx}].startTime`, {
        type: "manual",
        message: "Duration cannot be more than 12 hours",
      });
      return false;
    }

    return true;
  };

  const calculateTotalDuration = (timings, slotIdx) => {
    let totalTimings = 0;
    const compareToMidday = DateTime.now()
      .startOf("day")
      .plus({ hours: 12 })
      .toMillis();

    for (let n in timings) {
      if (timings[n]?.startTime && timings[n]?.endTime) {
        const start = normalizeDateTime(timings[n].startTime).toISO();
        const end = normalizeDateTime(timings[n].endTime).toISO();

        let endDateTime = DateTime.fromISO(end);
        if (
          DateTime.fromISO(start).toMillis() > DateTime.fromISO(end).toMillis()
        ) {
          if (
            DateTime.fromISO(start).toMillis() > compareToMidday &&
            DateTime.fromISO(end).toMillis() > compareToMidday
          ) {
            setError(`slots[${slotIdx}].timings[${n}].startTime`, {
              type: "manual",
              message: "Start time must be less than end time",
            });
            return -1;
          }
          endDateTime = endDateTime.plus({ days: 1 });
        }

        const diffInHours = endDateTime
          .diff(DateTime.fromISO(start), "hours")
          .toObject().hours;
        totalTimings += diffInHours;
      }
    }

    if (totalTimings > 12) {
      setError(`slots[${slotIdx}].timings[${timings.length - 1}].startTime`, {
        type: "manual",
        message: "Duration cannot be more than 12 hours per day",
      });
      return -1;
    }

    return totalTimings;
  };

  const checkTimingOverlap = (timings, slotIdx) => {
    for (let i = 0; i < timings.length; i++) {
      for (let j = 0; j < timings.length; j++) {
        if (i !== j) {
          const startI = normalizeDateTime(timings[i].startTime).toMillis();
          const endI = normalizeDateTime(timings[i].endTime).toMillis();
          const startJ = normalizeDateTime(timings[j].startTime).toMillis();
          const endJ = normalizeDateTime(timings[j].endTime).toMillis();

          if (
            (startI >= startJ && startI < endJ) ||
            (endI > startJ && endI <= endJ) ||
            (startI < startJ && endJ < endI)
          ) {
            setError(`slots[${slotIdx}].timings[${j}].endTime`, {
              type: "manual",
              message: "Duplicate timings are not allowed",
            });
            setError(`slots[${slotIdx}].timings[${j}].startTime`, {
              type: "manual",
              message: "Duplicate timings are not allowed",
            });
            return false;
          }
        }
      }
    }
    return true;
  };

  function checkDuplicateTimingsOnSubmit(slots) {
    console.log(slots, "slotsslotsslots");
    for (let k in slots) {
      const currentSlot = slots[k];
      console.log(currentSlot, " currentSlotcurrentSlot");
      if (!currentSlot?.timings?.length) continue;

      const timings = currentSlot.timings;

      for (let m in timings) {
        if (!validateTimingExists(timings[m], k, m)) return false;
        if (!validateTimingRange(timings[m], k, m, currentSlot.day))
          return false;
      }

      const totalDuration = calculateTotalDuration(timings, k);
      if (totalDuration === -1) return false;

      if (!checkTimingOverlap(timings, k)) return false;
    }

    return true;
  }

  const handleValues = (data) => {
    let flag = true;
    if (!data?.startDate) {
      flag = false;
      setError("startDate", {
        type: "manual",
        message: "Please select start date",
      });
    }
    if (!data?.endDate) {
      flag = false;
      setError("endDate", {
        type: "manual",
        message: "Please select end date",
      });
    }
    if (data?.startDate && data?.endDate) {
      let startDate = DateTime.fromJSDate(data?.startDate).toISODate();
      let endDate = DateTime.fromJSDate(data?.endDate).toISODate();
      if (DateTime.fromISO(startDate) > DateTime.fromISO(endDate)) {
        flag = false;
        setError("endDate", {
          type: "manual",
          message: "End date should be greater than start date",
        });
      }
      if (
        DateTime.fromJSDate(data?.startDate).plus({ weeks: 6 }).endOf("day") <
        DateTime.fromJSDate(data?.endDate)
      ) {
        flag = false;
        setError("endDate", {
          type: "manual",
          message: "End date should not exceed 6 weeks from the start date",
        });
      }
    }

    if (data?.slots && data.slots != undefined) {
      if (data?.slots?.length > 0) {
        if (!checkDuplicateTimingsOnSubmit(data?.slots)) {
          flag = false;
        }
      }
    }
    if (data?.slots && data?.slots?.length > 0) {
      let isTimingsAvailable = true;
      let slotsWithTimings = data?.slots.filter((x) => x?.timings?.length > 0);
      // console.log("slotsWithTimings", slotsWithTimings);
      if (slotsWithTimings?.length == 0) {
        isTimingsAvailable = false;
      } else if (slotsWithTimings?.length > 0) {
        // check if that slot timings aligns with any weekends
        if (data?.excludeWeekends) {
          let slotDays = slotsWithTimings.map((x) => x?.day);
          let weekends = data?.weekends;
          let filteredSlotsDays = slotDays.filter((x) => !weekends.includes(x));
          if (filteredSlotsDays?.length == 0) {
            isTimingsAvailable = false;
          }
        }
      }
      if (!isTimingsAvailable) {
        flag = false;
        // toaster.push(
        //   <Notification
        //     type={"error"}
        //     header={t("error", { defaultValue: "Error" })}
        //     closable
        //   >
        //     {t("pleaseSelectStartTimeAndEndTimeInWeeklyHours", {
        //       defaultValue:
        //         "Please select start time and end time in Weekly Hours",
        //     })}
        //   </Notification>,
        //   {
        //     placement: "topEnd",
        //   }
        // );
        ToasterNotification({
          type: "error",
          i18keyFormat:
            "pleaseSelectStartTimeAndEndTimeInWeeklyHourstSuccessful",
          message: "Please select start time and end time in Weekly Hours",
          options: { position: "top-right", autoClose: 5000 },
        });
      }
    }
    if (flag) {
      setOpenConfirmationModal(true);
    }
  };

  const onSubmit = async () => {
    let obj = {
      interviewID: "",
      campaignID: "",
      roundNumber: 1,
      userID: "",
      resumeID: "",
      startDate: "",
      endDate: "",
      timeZone: "",
      timeZoneName: "",
      timeZoneFullName: "",
      companyID: "",
      event: "",
      description: "",
      participants: [],
      availableTimings: [],
    };

    if (getValues()?.slots && getValues()?.slots?.length > 0) {
      let isTimingsAvailable = true;
      let slotsWithTimings = getValues()?.slots.filter(
        (x) => x?.timings?.length > 0,
      );
      // console.log("slotsWithTimings", slotsWithTimings);
      if (slotsWithTimings?.length == 0) {
        isTimingsAvailable = false;
      } else if (slotsWithTimings?.length > 0) {
        // check if that slot timings aligns with any weekends
        if (getValues()?.excludeWeekends) {
          let slotDays = slotsWithTimings.map((x) => x?.day);
          let weekends = getValues()?.weekends;
          let filteredSlotsDays = slotDays.filter((x) => !weekends.includes(x));
          if (filteredSlotsDays?.length == 0) {
            isTimingsAvailable = false;
          }
        }
      }
      if (slotsWithTimings && slotsWithTimings?.length > 0) {
        // console.log("slotsWithTimings", slotsWithTimings);
        for (let i in slotsWithTimings) {
          let timingObj = {
            day: "",
            timings: [],
          };
          timingObj.day = slotsWithTimings[i]?.day;
          let timings = slotsWithTimings[i]?.timings;
          if (timings?.length > 0) {
            let finalTimings = [];
            for (let k in timings) {
              if (timings[k]?.startTime != "" && timings[k]?.endTime != "") {
                finalTimings.push({
                  startTime: DateTime.fromJSDate(timings[k].startTime).toFormat(
                    "HH:mm",
                  ),
                  endTime: DateTime.fromJSDate(timings[k].endTime).toFormat(
                    "HH:mm",
                  ),
                });
              }
            }
            timingObj.timings = finalTimings;
          }
          obj.availableTimings.push(timingObj);
        }
      }
    }

    obj.description = getValues().description?.trim();
    let companyID = loaderDetails?.companyID;
    // obj.companyID = companyID ? companyID : "";
    let selectedTimeZone = optionSelected[0].label.match(
      /\((.+?)([+-]\d{2}:\d{2})\)/,
    );
    obj.timeZone = selectedTimeZone[2];
    obj.timeZoneFullName = optionSelected[0].value;
    obj.timeZoneName = selectedTimeZone[1];
    obj.startDate = DateTime.fromJSDate(getValues().startDate).toFormat(
      "dd-MM-yyyy",
    );
    obj.endDate = DateTime.fromJSDate(getValues().endDate).toFormat(
      "dd-MM-yyyy",
    );
    obj.resumeID = rid ? rid : "";
    obj.campaignID = searchParams.get("cid") ? searchParams.get("cid") : "";
    obj.userID = searchParams.get("uid") ? searchParams.get("uid") : "";
    obj.interviewID = searchParams.get("iid") ? searchParams.get("iid") : "";
    obj.roundNumber = searchParams.get("round")
      ? searchParams.get("round")
      : "";
    obj.companyID = searchParams.get("companyid")
      ? searchParams.get("companyid")
      : companyID
        ? companyID
        : "";
    obj.clientID = searchParams.get("clientid")
      ? searchParams.get("clientid")
      : "";
    obj.from =
      searchParams.get("uid") && searchParams.get("rid")
        ? "Live Video Without Campaign"
        : "";

    let response = await insertAvailability(obj);
    console.log(response, "insertAvailabilityinsertAvailability");
    if (
      !response?.result?.status &&
      response?.result?.message.includes("Something went wrong")
    ) {
      // toaster.push(
      //   <Notification
      //     type={"error"}
      //     header={t("error", { defaultValue: "Error" })}
      //     closable
      //   >
      //     {t("somethingWentWrongPleaseTryAgain", {
      //       defaultValue: "Something Went Wrong, Please Try Again",
      //     })}
      //   </Notification>,
      //   {
      //     placement: "topEnd",
      //   }
      // );
      ToasterNotification({
        type: "error",
        i18keyFormat: "somethingWentWrongPleaseTryAgain",
        message: "Something Went Wrong, Please Try Again",
        options: { position: "top-right", autoClose: 5000 },
      });
    } else if (
      !response?.result?.status &&
      response?.result?.message.includes("ResumeID is mandatory")
    ) {
      // toaster.push(
      //   <Notification
      //     type={"error"}
      //     header={t("error", { defaultValue: "Error" })}
      //     closable
      //   >
      //     {t("resumeIDIsMandatory", {
      //       defaultValue: "ResumeID is mandatory",
      //     })}
      //   </Notification>,
      //   {
      //     placement: "topEnd",
      //   }
      // );
      ToasterNotification({
        type: "error",
        i18keyFormat: "resumeIDIsMandatory",
        message: "ResumeID is mandatory",
        options: { position: "top-right", autoClose: 5000 },
      });
      handleClose();
    } else if (!response?.result?.status) {
      // toaster.push(
      //   <Notification
      //     type={"error"}
      //     header={t("error", { defaultValue: "Error" })}
      //     closable
      //   >
      //     {t("slotsAreNotAvailableForSelectedDates", {
      //       defaultValue: "Slots are not available for selected dates",
      //     })}
      //   </Notification>,
      //   {
      //     placement: "topEnd",
      //   }
      // );
      ToasterNotification({
        type: "error",
        i18keyFormat: "slotsAreNotAvailableForSelectedDates",
        message: "Slots are not available for selected dates",
        options: { position: "top-right", autoClose: 5000 },
      });
      handleClose();
    } else {
      // toaster.push(
      //   <Notification
      //     type={"success"}
      //     header={t("success", { defaultValue: "Success" })}
      //     closable
      //   >
      //     {t("slotsPreparedSuccessfully", {
      //       defaultValue: "Slots prepared successfully",
      //     })}
      //   </Notification>,
      //   {
      //     placement: "topEnd",
      //   }
      // );
      ToasterNotification({
        type: "success",
        i18keyFormat: "slotsPreparedSuccessfully",
        message: "Slots prepared successfully",
        options: { position: "top-right", autoClose: 5000 },
      });
      handleClose();
      clearErrors();
      setDateClear(true);
      resetField("startDate");
      resetField("endDate");
      setValue("description", "");
    }
  };

  const handleClose = () => {
    setOpenConfirmationModal(false);
  };

  return (
    <>
      {activeCampaignLoading ? (
        <div className="card w-100">
          <div className="card-body">
            <Placeholder.Grid rows={6} columns={2} active />
          </div>
        </div>
      ) : !isActiveCampaign ? (
        <div className="d-flex justify-content-center">
          <img src="/assets/images/campaignClosed-min.png" width={800} />
        </div>
      ) : (
        <>
          {showModal ? (
            <React.Suspense fallback={<Loading />}>
              <CreateResumeNewLayout
                rid={rid}
                setRId={setRId}
                setShowModal={setShowModal}
              />
            </React.Suspense>
          ) : null}
          <div className="container pt-5 careerscontainer">
            <div className="card py-2">
              <div className="card-header">
                <div className="row">
                  <div className="col-6">
                    <FontAwesomeIcon
                      icon={faCalendarDays}
                      className="userIcon mx-2"
                    />
                    <span className="mt-3 availability-title">
                      <Trans
                        i18nKey="myAvailability"
                        defaults="My Availability"
                      />
                    </span>
                  </div>
                  <div className="col-6 d-flex justify-content-end">
                    <button
                      disabled={isLoading}
                      className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                      onClick={handleSubmit(handleValues)}
                    >
                      {isLoading && (
                        <span className="me-1 mt-1">
                          <Loader />
                        </span>
                      )}
                      <span>
                        {" "}
                        <Trans i18nKey="create" defaults="Create" />
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="p-5 pt-3">
                <Form>
                  <div className="row">
                    <React.Suspense fallback={<Loading />}>
                      <Description register={register} />
                    </React.Suspense>
                  </div>
                  <div className="row mt-2">
                    <React.Suspense fallback={<Loading />}>
                      <Dates
                        control={control}
                        register={register}
                        startDateRef={startDateRef}
                        endDateRef={endDateRef}
                        errors={errors}
                        getValues={getValues}
                        setDateClear={setDateClear}
                        dateClear={dateClear}
                        clearErrors={clearErrors}
                        setError={setError}
                        companyID={
                          searchParams.get("companyid")
                            ? searchParams.get("companyid")
                            : loaderDetails?.companyID
                        }
                      />
                    </React.Suspense>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-12 p-0">
                      <div className=" m-0">
                        <Form.ControlLabel>
                          <b>
                            <Trans i18nKey="timeZone" defaults="Timezone" />
                          </b>
                        </Form.ControlLabel>
                        <span className="text-danger px-1">{"*"}</span>
                      </div>
                      <React.Suspense fallback={<Loading />}>
                        <TimeZoneList
                          setOptionSelected={setOptionSelected}
                          optionSelected={optionSelected}
                          timeZone={timeZone}
                          setTimeZone={setTimeZone}
                          target={"Availability"}
                        />
                      </React.Suspense>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <Panel
                      header={
                        <span className="">
                          <b>
                            <Trans
                              i18nKey="weeklyHours"
                              defaults="Weekly Hours"
                            />
                          </b>
                          <span className="text-danger px-1">{"*"}</span>
                        </span>
                      }
                      collapsible
                      bordered
                      className="shadow-sm"
                      defaultExpanded={true}
                      // className="panel-shadow"
                    >
                      <React.Suspense fallback={<Loading />}>
                        <WeeklyHours
                          control={control}
                          register={register}
                          handleSubmit={handleSubmit}
                          resetField={resetField}
                          clearErrors={clearErrors}
                          setError={setError}
                          errors={errors}
                          setValue={setValue}
                          getValues={getValues}
                          isAvailabilityLoading={isAvailabilityLoading}
                          weeklyHourData={weeklyHourData}
                          optionSelected={optionSelected}
                        />
                      </React.Suspense>
                    </Panel>
                  </div>
                </Form>
              </div>
            </div>
          </div>
          <Modal size={"lg"} open={openConfirmationModal} onClose={handleClose}>
            <Modal.Header>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-3">
              <span className="fs-6 text-dark">
                <Trans
                  i18nKey="weAreSubmittingYourAvailabilityToTheRecruitingTeam"
                  defaults="We are submitting your availability to the recruiting team. Please note this is not a confirmation and is subject to availability. Would you like to proceed?"
                />
              </span>
            </Modal.Body>
            <Modal.Footer>
              <div className="row pt-2">
                <div className="col-md-12 col-sm-12 d-flex justify-content-between">
                  <span>
                    <button
                      className="btn btn-sm btn-light"
                      onClick={handleClose}
                    >
                      <Trans i18nKey="cancel" defaults="Cancel" />
                    </button>
                  </span>
                  <span>
                    <button
                      className="btn btn-sm btn-primary"
                      disabled={isLoading}
                      onClick={handleSubmit(onSubmit)}
                    >
                      {isLoading && (
                        <span className="me-1 mt-1">
                          <Loader />
                        </span>
                      )}
                      <span className="px-1">
                        <Trans i18nKey="yes" defaults="Yes" />
                      </span>
                    </button>
                  </span>
                </div>
              </div>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </>
  );
};

export default CareersAvailability;
